module.exports = __webpack_public_path__ + "img/content_bg5.3cedffa.png";